import { render } from "./ReportContentBody.vue?vue&type=template&id=6782bc2b"
import script from "./ReportContentBody.vue?vue&type=script&lang=js"
export * from "./ReportContentBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__